import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=e76470fc&scoped=true"
var script = {}
import style0 from "./PhoneIcon.vue?vue&type=style&index=0&id=e76470fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76470fc",
  null
  
)

export default component.exports